export default __webpack_public_path__ + "static/media/Frame12.d93b23fb.png";